import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import NProgress from 'nprogress'

import Grid from '../Grid';

import Train from '../../services/train.js';

class Discoveries extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      discoveries: [],
      hasMore: undefined,
      page: 1
    }

  }

  componentDidMount() {
    this.fetchData(1);
  } 

  componentWillReceiveProps(newProps) {
  }

  fetchData(page) {
    NProgress.start();

    Train.fetchUsersDiscoveries({page})
    .then((data) => {
      this.setState({
        discoveries: this.state.discoveries.concat(data.artists),
        hasMore: data.pagination.page*data.pagination.perPage < data.pagination.total,
        page
      });
      NProgress.done();
    });
  }

  loadMore() {
    if (this.state.hasMore) {
      this.fetchData(this.state.page+1)
    }
  }

  render() {

    return (

      <div className="infinite">

        <InfiniteScroll
          loadMore={this.loadMore.bind(this)}
          hasMore={this.state.hasMore}
          loader={<h4>Loading...</h4>}
          useWindow={true}
          >
          <Grid title="Discoveries" mappable={true} mapContext="discovered" mapSearchTerm={'Discovered Artists'} mapType="artists" type="artist" playable={true} elements={this.state.discoveries} />
        </InfiniteScroll>

      </div>

    );

  }
}

export default Discoveries;



// WEBPACK FOOTER //
// ./src/js/components/explore/Discoveries.jsx